export default __webpack_public_path__ + "static/media/MongoDB_Logo.057de5cd.png";